import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';

export type InventoryItem = {
    readonly version: string;
    readonly id: number;
    readonly name: string;
    readonly symbol: string;
};

export class InventoryQuery extends Query<InventoryItem[]> { }

export class InventoryQueryHandlerBase implements QueryHandler<InventoryQuery, InventoryItem[]> {
    private static Url = TaggedUrl.join('inventory', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(_: InventoryQuery): Promise<InventoryItem[]> {
        const { data } = await this.http.get<InventoryItem[]>(InventoryQueryHandlerBase.Url);
        return data;
    }
}
